import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=081fc78a&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=081fc78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fc78a",
  null
  
)

export default component.exports